import styled from '@emotion/styled';
import { AccountCircle as UserIcon } from '@material-ui/icons';

const SmallUserIcon = styled(UserIcon)({
  width: 18,
  height: 18
});

export default SmallUserIcon;
